import React from 'react';
import Button from 'react-bootstrap/Button';
import { FaDownload  } from "react-icons/fa";
import ReactExport from 'react-export-excel';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const SiteListXls = (props) => {


    const headerStyle = {fill: {patternType: "solid", fgColor: {rgb: "FFD364"}},}; //a6c4e4
    const headerStyle2 = {font: {bold: true, color: {rgb: "000000"}},};

    const siteList = props.siteList
    const location = props.location && props.location.replace('&','and')
    const country = props.country && props.country.replace('&','and')

    const dataSiteList = []

    const headSiteList = [
        [
            {value: "Site", style: headerStyle},
            {value: "Address", style: headerStyle},
            {value: "Country", style: headerStyle},
            {value: "Location", style: headerStyle},
            {value: "Latitude", style: headerStyle},
            {value: "Longitude", style: headerStyle},
            {value: "Status", style: headerStyle},
        ],
    ]

    if (siteList.length >0){
        for (let i = 0; i < siteList.length; i++) {
            dataSiteList.push([
                siteList[i].name,
                siteList[i].address,
                siteList[i].country,
                siteList[i].location,
                siteList[i].latitude,
                siteList[i].longitude,
                siteList[i].status,
            ])
        }
    }
    
    let dateFrom = ""
    const d = new Date();
    dateFrom = ("0"+d.getDate()).slice(-2) + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" + d.getFullYear();

    let title = ""
    if (country!=="") title = country
    if (location!=="") 
        if (title==="") title = location
        else title += " - " + location

    const dt = "Date:" + dateFrom 

    const dataSet = [
        {   columns: [title, dt],
            data: [ 
            [{value:"Sites", style: headerStyle2}],...headSiteList,...dataSiteList, "",
                ],
        },
    ]

        return (
            <div>
                <ExcelFile filename="Ipsum Cloud - Sites" element={<Button size="md" className='m-0' variant="secondary">Export to Excel &nbsp;<FaDownload /></Button>}>
					<ExcelSheet dataSet={dataSet} name="Ipsum Cloud - Sites" />
				</ExcelFile>
            </div>
        );
}


export default SiteListXls;


